import axios from 'axios';

// Isolated client for the Daily Challenge stack (challenge.app.lxop.in), mirroring the other service
// clients. Routes are identical to the ones the main stack served (/challenge, /challenge/verify),
// and both read the same DynamoDB table, so this is a transport change only.
//
// Falls back to the main API when unset, which keeps a stale build working
// against the old endpoints until the challenge functions are removed from the
// main stack.
//
// NOTE: /challenge/verify is the bot check on Login, Signup, Support and
// TeamPlans, so this client sits in the sign-in path. It deliberately does NOT
// clear the session and redirect on 401 the way the other clients do — a
// challenge call failing must not log anyone out, and these screens are often
// reached while signed out anyway.
const BASE_URL =
  (typeof window !== 'undefined' && window.electronEnv?.challengeApiUrl) ||
  process.env.REACT_APP_CHALLENGE_API_URL ||
  'https://challenge.app.lxop.in';

const challengeApi = axios.create({ baseURL: BASE_URL, timeout: 20000 });

challengeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('lxops_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

challengeApi.interceptors.response.use(
  (res) => res,
  (err) => {
    return Promise.reject(err);
  }
);

export default challengeApi;
